var map = {
	"./img_0.png": 531,
	"./img_1.png": 532,
	"./img_10.png": 533,
	"./img_2.png": 534,
	"./img_3.png": 535,
	"./img_4.png": 536,
	"./img_5.png": 537,
	"./img_6.png": 538,
	"./img_7.png": 539,
	"./img_8.png": 540,
	"./img_9.png": 541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;